import { faUserHeadset } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Accordion, Card, useAccordionButton } from 'react-bootstrap';

import './agentScriptBox.scss';

interface AgentScriptBoxProps {
  scriptTitle: string;
  agentScript: string;
}

export const AgentScriptBox = ({ scriptTitle, agentScript }: AgentScriptBoxProps): JSX.Element => {
  const [activeKey, setActiveKey] = useState<string>('0');

  const AccordionHeader = (): JSX.Element => {
    const decoratedOnClick = useAccordionButton('0');

    return (
      <Card.Header onClick={decoratedOnClick}>
        <FontAwesomeIcon icon={faUserHeadset} size="lg" />
        <h2>{(scriptTitle as string).toLocaleUpperCase()}</h2>
      </Card.Header>
    );
  };

  return (
    <div className="agent-script-accordion">
      <Accordion activeKey={activeKey} onSelect={(eventKey) => setActiveKey(eventKey as string)}>
        <Card>
          <AccordionHeader />
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <p className="agent-script-content">{agentScript}</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};
